import dynamic from "next/dynamic";
import { SVGAttributes } from "react";

import { Icons } from "./types";

type IconSize = "sm" | "md" | "lg";

type IconProps = {
  type?: Icons;
  size?: IconSize;
  label?: string;
  className?: string;
};

enum Sizes {
  sm = "16px",
  md = "24px",
  lg = "48px",
}

const LargeIcons = [
  "container_lg",
  "delivered",
  "how_to",
  "info",
  "email",
  "exclamation",
  "question",
  "return",
  "truck",
];

export const Icon = ({
  type = "info",
  size = "md",
  label,
  className,
}: IconProps) => {
  const iconSize = Sizes[size];

  const largeIcon = size === "lg" && LargeIcons.includes(type);
  const filename = largeIcon ? `${type}-lg` : type;

  const SvgIcon = dynamic<SVGAttributes<SVGSVGElement> & { title?: string }>(
    import(`@/assets/icons/${filename}.svg`)
  );

  return (
    <SvgIcon
      height={iconSize}
      width={iconSize}
      className={className}
      title={label ?? type}
    />
  );
};
